module.exports = __webpack_public_path__ + "img/[勾引].b90e66a3.svg";